<template>
    <select :value="value"
        class="form-control"
        :required="required"
        @change="$emit('input', $event.target.value)">
        <option v-for="(status, index) in filteredStatuses"
            :value="status"
            :key="index">{{ status }}</option>
    </select>
</template>

<script>
import { availableMemberStatuses, defaultMemberStatus } from '../helpers'

export default {
    computed: {
        filteredStatuses() {
            // Filter available statuses based on allowedStatuses prop
            return this.allowedStatuses.length > 0
                ? availableMemberStatuses().filter(status => this.allowedStatuses.includes(status))
                : availableMemberStatuses()
        }
    },
    props: {
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: false,
            default: defaultMemberStatus(),
        },
        allowedStatuses: {
            type: Array,
            required: false,
            default: () => []
        }
    }
}
</script>
